<div class="w-full flex flex-col gap-2">
  <label for="claim-select" class="text-sm font-medium text-gray-700">Tipo de reclamo</label>
  <div class="relative w-full">
    <select
      id="claim-select"
      [(ngModel)]="selectedClaim"
      (ngModelChange)="onSelectClaim($event)"
      class="w-full appearance-none rounded-md border border-gray-300 bg-white text-gray-700 text-sm shadow-sm px-3.5 py-2.5 pr-10 focus:border-amber-500 focus:ring focus:ring-amber-200 focus:ring-opacity-50 transition-colors"
      [class.border-red-500]="!selectedClaim"
    >
      @for (claim of listClaims(); track claim.id) {
        <option [value]="claim.id">{{ claim.name }}</option>
      }
    </select>
    <span class="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
      <i class="fas fa-chevron-down text-xs"></i>
    </span>
  </div>
  <p class="text-xs text-gray-500">Selecciona el motivo del reclamo.</p>
</div>
